import styled, { css } from 'styled-components'

interface FlexProps {
  flexDirection?: 'column' | 'column-reverse' | 'row' | 'row-reverse'
  justifyContent?:
    | 'space-between'
    | 'space-around'
    | 'space-evenly'
    | 'stretch'
    | 'flex-start'
    | 'flex-end'
}

export const DynamicFlex = styled.div<FlexProps>`
  display: flex;
  ${({ flexDirection }) =>
    flexDirection
      ? css`
          flex-direction: ${flexDirection};
        `
      : ''}

  ${({ justifyContent }) =>
    justifyContent
      ? css`
          justify-content: ${justifyContent};
        `
      : ''}
`



// WEBPACK FOOTER //
// ./src/components/DynamicFlex/index.tsx